import React, { useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { UserContext } from "../../contexts/UserContext";

const PENALTIES_BY_PLAYER_ID = gql`
  query PenaltiesByPlayerID($player_ID: String) {
    penaltiesByPlayerID(player_ID: $player_ID) {
      event_ID
      y
      z
      outcome
    }
  }
`;
const Button = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #181d25;
  min-height: 50px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  padding: 0.2em;
  cursor: pointer;
  :hover {
    background-color: #db0a41;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: cetner;
`;
const Caption = styled.div`
  display: flex;
  justify-content: center;
  font-size: 0.8em;
  text-align: center;
`;
export default function EFLPlayer({
  player,
  previewGraphic,
  game,
  sky,
  countries,
  period,
  selectedSubPlayer,
  allOptaEvents,
}) {
  const { user, signOut, teams: user_teams } = useContext(UserContext);
  const [getPenalties] = useLazyQuery(PENALTIES_BY_PLAYER_ID, {
    fetchPolicy: "network-first",
  });

  return (
    <>
      <Button
        onClick={() => {
          previewGraphic("Name", {
            player: player,
            subtext: player?.team?.name,
            team: player?.team,
            sky: sky,
            countries: countries,
            game,
          });
        }}
      >
        Name
      </Button>

      <Button
        onClick={() => {
          previewGraphic("Card", {
            player,
            cardType: 1,
            team: player?.team,

            countries: countries,
            game,
            clock: true,
          });
        }}
      >
        Yellow Card
      </Button>

      <Button
        onClick={() => {
          previewGraphic("Card", {
            player,
            cardType: 2,
            team: player?.team,
            game,
            countries: countries,
            clock: true,
          });
        }}
      >
        2nd Yellow Card
      </Button>

      <Button
        onClick={() => {
          previewGraphic("Card", {
            player,
            cardType: 3,
            team: player?.team,
            game,
            countries: countries,
            clock: true,
          });
        }}
      >
        Red Card
      </Button>
      {!player.title &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") && (
          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 1,
                team: player?.team,
                sky: sky,
                countries: countries,
                game,
                clock: false,
              });
            }}
          >
            L3 Yellow Card
          </Button>
        )}
      {!player.title &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") && (
          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 2,
                team: player?.team,
                sky: sky,
                countries: countries,
                game,
                clock: false,
              });
            }}
          >
            L3 2nd Yellow Card
          </Button>
        )}
      {!player.title &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") && (
          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 3,
                team: player?.team,
                sky: sky,
                countries: countries,
                game,
                clock: false,
              });
            }}
          >
            L3 Red Card
          </Button>
        )}
      {user_teams?.findIndex((t) => t.name === "WSL_TEAM") === -1 &&
        user?.username !== "sky" &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                customStatType: "CB",
              });
            }}
          >
            Player stats
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky" || user?.username === "PremierSports") &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                type: "Attack",
              });
            }}
          >
            Player stats Attack
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky" || user?.username === "PremierSports") &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                type: "Defence",
              });
            }}
          >
            Player stats Defence
          </Button>
        )}

      {user_teams?.findIndex((t) => t.name === "WSL_TEAM") === -1 &&
        user?.username !== "sky" && game?.dfb_ID === null &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                full_frame: true,
              });
            }}
          >
            FF Player stats
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                full_frame: true,
                type: "Attack",
              });
            }}
          >
            FF Player Stats Attack
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                full_frame: true,
                type: "Defence",
              });
            }}
          >
            FF Player Stats Defence
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        !player.title && game?.dfb_ID === null && (
          <Button
            onClick={() => {
              previewGraphic("TouchMap", {
                player,
                team: player?.team,
                opta_events: allOptaEvents,
                game,
              });
            }}
          >
            Touch Map
          </Button>
        )}
        {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        !player.title && (
          <Button
            onClick={() => {
              previewGraphic("PlayerHeatmap", {
                player,
                team: player?.team,
                opta_events: allOptaEvents,
                game,
              });
            }}
          >
            Heat Map
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        !player.title && game?.dfb_ID === null && (
          <Button
            onClick={() => {
              previewGraphic("PassMap", {
                player,
                team: player?.team,
                opta_events: allOptaEvents,
                game,
              });
            }}
          >
            Pass Map
          </Button>
        )}
      {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
        !player.title && game?.dfb_ID === null && (
          <Button
            onClick={() => {
              previewGraphic("ShotMap", {
                player,
                team: player?.team,
                opta_events: allOptaEvents,
                game,
              });
            }}
          >
            Shot Map
          </Button>
        )}
      {!player.title && (
          <Button
            onClick={async () => {
              let { data } = await getPenalties({
                variables: { player_ID: player?._id },
              });
              let penalties = [...(data?.penaltiesByPlayerID || [])]
                .sort((a, b) => b.event_ID - a.event_ID)
                .slice(0, 5);
              previewGraphic("PenaltyHistory", {
                player,
                team: player?.team,
                game,
                penalties,
              });
            }}
          >
            Penalty History
          </Button>
        )}

      {!player.title && (
        <Button
          onClick={() => {
            previewGraphic("POTM", {
              player,
              team: player?.team,
              game,
            });
          }}
        >
          POTM
        </Button>
      )}

      {player.stories &&
        player.stories.map((stat) => {
          return (
            <Button
              onClick={() => {
                previewGraphic("Name", {
                  team: player?.team,
                  player: player,
                  sky: sky,
                  subtext: stat.story,
                  countries: countries,
                  shirt_number:
                    player.shirt_number ?? player.opta_shirt_number ?? "",
                  game,
                });
              }}
            >
              <Caption>{stat.story}</Caption>
            </Button>
          );
        })}
      {selectedSubPlayer && (
        <Button
          onClick={() => {
            previewGraphic("Substitution", {
              players: [selectedSubPlayer, player],
              team: player?.team,
              game: game,
              clock: true,
            });
          }}
        >
          Substitution{" "}
          {user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky"
            ? " U3"
            : ""}
        </Button>
      )}
      {selectedSubPlayer &&
        (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
          user?.username === "sky") && (
          <Button
            onClick={() => {
              previewGraphic("Substitution", {
                players: [selectedSubPlayer, player],
                team: player?.team,
                game: game,
                clock: false,
              });
            }}
          >
            Substitution L3
          </Button>
        )}
    </>
  );
}
